import styled from '@emotion/styled'

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
`
